import { forwardRef, useMemo } from 'react';
import { ImageBase } from '../image-base';
import { Props } from './types';
import { getBorderRadiusBySize } from './model';

export const Layout = forwardRef<HTMLDivElement, Props>(function Component(
  { size = 40, borderRadius, style, ...props },
  forwardedRef
) {
  const styles = useMemo(
    () => ({
      ...style,
      borderRadius: borderRadius ?? getBorderRadiusBySize(size),
    }),
    [borderRadius, style, size]
  );

  return <ImageBase {...props} size={size} style={styles} ref={forwardedRef} />;
});
